import { Loading, CustomTooltip } from "../../components"
import React, { useEffect, useState } from 'react';
import Wrapper from '../../assets/wrappers/DiagramsAnnualComparison';
import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from 'recharts';
import calculations from '../../utils/calculations';
import { useAppContext } from "../../context/appContext";
import MultiRangeSlider from "../../components/MultiRangeSlider";

const DiagramsAnnualComparison = () => {
    const {
        isLoading,
        getInformationItems,
        informationItems,
    } = useAppContext()

    var dataToDisplay = []
    const [firstYearToDisplay, setfirstYearToDisplay] = useState(1900);
    const [lastYearToDisplay, setlastYearToDisplay] = useState(1900);
    var firstYear = 1900;
    var lastYear = 1900;

    useEffect(() => {
        getInformationItems();
    }, [])

    if (informationItems) {
        dataToDisplay = calculations.generateAnnualComparison(informationItems, firstYearToDisplay, lastYearToDisplay);
        firstYear = dataToDisplay[0] ? dataToDisplay[0].year : 1900;
        lastYear = dataToDisplay[dataToDisplay.length - 1] ? dataToDisplay[dataToDisplay.length - 1].year : 1900;
    }

    return (
        <Wrapper>
            <h3>Jahresvergleich</h3>
            {
                isLoading ? <Loading center /> :
                    <>
                        <form className='form'>
                            <h4>Filter</h4>
                            <div className='form-center'>
                                <MultiRangeSlider
                                    min={Object.keys(informationItems)[0]}
                                    max={Object.keys(informationItems)[Object.keys(informationItems).length - 1]}
                                    onChange={
                                        ({ min, max }) => {
                                            setfirstYearToDisplay(min);
                                            setlastYearToDisplay(max);
                                        }
                                    } />
                            </div>
                        </form>
                        {Object.keys(informationItems).length === 0 ? <h5>Keine Einträge gefunden...</h5> :
                            <div className='diagramsContainer'>
                                <div className='diagramAndHeading'>
                                    <h4>Stromverbrauch von {firstYear} bis {lastYear} in kWh</h4>
                                    <div className='diagram'>
                                        <ResponsiveContainer>
                                            <LineChart
                                                data={dataToDisplay}
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: 20,
                                                    bottom: 5
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="year" />
                                                <YAxis domain={[0, 4000]} allowDataOverflow={true} />
                                                <Tooltip content={<CustomTooltip />} />
                                                <Legend />
                                                <Line type="monotone" name="Stromverbrauch" dataKey="consumptionElectricity" stroke="red" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                <div className='diagramAndHeading'>
                                    <h4>Heizungsverbrauch von {firstYear} bis {lastYear} in kWh</h4>
                                    <div className='diagram'>
                                        <ResponsiveContainer>
                                            <LineChart
                                                data={dataToDisplay}
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: 20,
                                                    bottom: 5
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="year" />
                                                <YAxis domain={[0, 25000]} allowDataOverflow={true} />
                                                <Tooltip content={<CustomTooltip />} />
                                                <Legend />
                                                <Line type="monotone" name="Heizungsverbrauch" dataKey="consumptionHeating" stroke="orange" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                <div className='diagramAndHeading'>
                                    <h4>PV-Ertrag von {firstYear} bis {lastYear} in kWh</h4>
                                    <div className='diagram'>
                                        <ResponsiveContainer>
                                            <LineChart
                                                data={dataToDisplay}
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: 20,
                                                    bottom: 5
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="year" />
                                                <YAxis domain={[0, 9000]} allowDataOverflow={true} />
                                                <Tooltip content={<CustomTooltip />} />
                                                <Legend />
                                                <Line type="monotone" name="PV-Ertrag" dataKey="gainPhotovoltaic" stroke="green" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>

                                <div className='diagramAndHeading'>
                                    <h4>Wasserverbrauch von {firstYear} bis {lastYear} in m³</h4>
                                    <div className='diagram'>
                                        <ResponsiveContainer>
                                            <LineChart
                                                data={dataToDisplay}
                                                margin={{
                                                    top: 5,
                                                    right: 30,
                                                    left: 20,
                                                    bottom: 5
                                                }}
                                            >
                                                <CartesianGrid strokeDasharray="3 3" />
                                                <XAxis dataKey="year" />
                                                <YAxis domain={[0, 110]} allowDataOverflow={true} />
                                                <Tooltip content={<CustomTooltip />} />
                                                <Legend />
                                                <Line type="monotone" name='Wasserverbrauch' dataKey="consumptionWater" stroke="blue" />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </div>
                                </div>
                            </div>
                        }
                    </>
            }
        </Wrapper>
    )
}

export default DiagramsAnnualComparison